import { register } from 'async-ops';
import { getDefaultOptions, throwExceptionErrors } from '../../../utils/fetch';
import { callMdaePublicApi } from "../../../call-web-api";

export const ATTACH_DOCUMENT = 'ATTACH_DOCUMENT';

export const service = async (data) => {

  const response: any = await callMdaePublicApi({
    type: 'post',
    contentType: 'application/json',
    url: '/Api/Document/AtttachDocuments',
    isRoutedApiCall: true,
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  })
  throwExceptionErrors(response);
  return response;
};

const mockData = () => {
  return ([])
};

const mock = () => Promise.resolve(mockData());

register(ATTACH_DOCUMENT, service, mock);
